export interface CookieOptions {
  domain?: string;
  path?: string;
  maxAgeSeconds?: number;
  secure?: boolean;
  sameSite?: "Lax" | "Strict" | "None";
}

export class CookieStorage {
  public static get(name: string): string | null {
    if (typeof document === "undefined") return null;
    const prefix = `${encodeURIComponent(name)}=`;
    const cookies = document.cookie ? document.cookie.split("; ") : [];
    for (const c of cookies) {
      if (c.indexOf(prefix) === 0) {
        return decodeURIComponent(c.substring(prefix.length));
      }
    }
    return null;
  }

  public static set(name: string, value: string, options: CookieOptions = {}): boolean {
    if (typeof document === "undefined") return false;
    try {
      const path = options.path || "/";
      const maxAge = options.maxAgeSeconds !== undefined ? options.maxAgeSeconds : 365 * 24 * 60 * 60; // 1 year default
      const sameSite = options.sameSite || "Lax";
      const secure = options.secure !== undefined ? options.secure : (typeof location !== "undefined" && location.protocol === "https:");

      let cookieStr = `${encodeURIComponent(name)}=${encodeURIComponent(value)}; Path=${path}; Max-Age=${maxAge}; SameSite=${sameSite}`;

      if (secure) {
        cookieStr += "; Secure";
      }

      if (options.domain) {
        cookieStr += `; Domain=${options.domain}`;
      }

      document.cookie = cookieStr;
      return true;
    } catch {
      return false;
    }
  }

  public static remove(name: string, options: CookieOptions = {}): void {
    this.set(name, "", { ...options, maxAgeSeconds: -1 });
  }
}
